import CircularProgress from '@mui/material/CircularProgress'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'

export const handleCustomIconForInfo = (icon: string) => {
  switch (icon) {
    case 'circularProgressWhite':
      return <CircularProgress size={'1.25rem'} style={{ color: 'white' }} />
    default:
      return <InfoOutlinedIcon fontSize="inherit" />
  }
}
